import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { env } from '../config/env';
import { User } from '../models/types';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="page">
      <h1>Users</h1>
      <div class="card">
        <h3>Invite editor/admin</h3>
        <input [(ngModel)]="email" placeholder="Email" />
        <input [(ngModel)]="fullName" placeholder="Full name" />
        <input [(ngModel)]="password" type="password" placeholder="Password" />
        <select [(ngModel)]="role">
          <option value="editor">Editor</option>
          <option value="admin">Admin</option>
        </select>
        <button (click)="create()">Create</button>
        <p class="err" *ngIf="error()">{{ error() }}</p>
      </div>
      <div class="card" *ngFor="let u of users()">
        <strong>{{ u.email }}</strong>
        <div class="meta">{{ u.role }} · {{ u.full_name || '—' }}</div>
      </div>
    </div>
  `,
  styles: [
    `
      .page {
        display: grid;
        gap: 16px;
      }
      h1,
      h3 {
        margin: 0;
        font-family: Georgia, serif;
      }
      .card {
        background: white;
        border-radius: 16px;
        padding: 16px;
        display: grid;
        gap: 8px;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
      }
      input,
      select {
        border: 1px solid #cbd5e1;
        border-radius: 10px;
        padding: 10px;
      }
      button {
        border: 0;
        background: #0f766e;
        color: white;
        border-radius: 10px;
        padding: 10px 14px;
        width: fit-content;
        cursor: pointer;
      }
      .meta {
        color: #64748b;
      }
      .err {
        color: #b91c1c;
      }
    `,
  ],
})
export class UsersPage implements OnInit {
  users = signal<User[]>([]);
  email = '';
  fullName = '';
  password = '';
  role: 'admin' | 'editor' = 'editor';
  error = signal('');

  constructor(private readonly http: HttpClient) {}

  async ngOnInit(): Promise<void> {
    this.users.set(await firstValueFrom(this.http.get<User[]>(`${env.apiUrl}/api/v1/auth/users`)));
  }

  async create(): Promise<void> {
    this.error.set('');
    try {
      const created = await firstValueFrom(
        this.http.post<User>(`${env.apiUrl}/api/v1/auth/users`, {
          email: this.email,
          full_name: this.fullName,
          password: this.password,
          role: this.role,
        }),
      );
      this.users.set([created, ...this.users()]);
      this.email = '';
      this.fullName = '';
      this.password = '';
    } catch (e: any) {
      this.error.set(e?.error?.detail || 'Create failed');
    }
  }
}
